import React from "react";
import loadingGif from '../Assests/Skillbrew logo (Card (Square)) (1).gif'
import loading from '../Assests/SkillbrewlogoCardSquare1-ezgif.com-gif-maker.gif'


const Spinner=()=>{
    return(
        <>
        <div className="preloader">
            <div className="frame">
                <div className="center">
                <img src={loading}alt="Loading..." width="100" height="100"/>
                </div>
           
            </div>

</div>
        </>
    )
}

export default Spinner